// extracted by mini-css-extract-plugin
export var cardHeader = "_g9-0";
export var reorderHandle = "_g9-3";
export var titleArea = "_g9-1";
export var titleAreaWithHandle = "_g9-2";